module.exports = __webpack_public_path__ + "assets/img/xjgs.32b6bb8f.png";